import {Checkbox as CheckboxPrimitive} from "@base-ui/react/checkbox"
import {clsx} from "clsx"
import styles from "./Checkbox.module.css"


function Checkbox({
					  className,
					  children,
					  ...props
				  }: CheckboxPrimitive.Root.Props) {
	return (
		<CheckboxPrimitive.Root
			data-slot="checkbox"
			className={clsx(styles.root, className)}
			{...props}
		>
			<CheckboxPrimitive.Indicator
				data-slot="checkbox-indicator"
				className={styles.indicator}
				keepMounted /* needed for css animation of the check */
			/>
		</CheckboxPrimitive.Root>
	)

}

export {Checkbox}
